import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useAccount } from 'hooks/use-account';
// Lazy load the federated component
const TaskAgentPreviewPage = /*#__PURE__*/ React.lazy(()=>// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    import('agentBuilder/TaskAgentPreviewPage').then((module)=>({
            default: module.TaskAgentPreviewPage
        })));
const AgentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--white-100);
  overflow: hidden;
`;
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: var(--white-100);
  padding: 24px;
`;
const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid var(--gray-20);
  border-top: 3px solid var(--primary-50);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const LoadingText = styled.p`
  font-size: 16px;
  color: var(--gray-60);
  margin-top: 16px;
  text-align: center;
`;
const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: var(--white-100);
  padding: 24px;
`;
const ErrorText = styled.p`
  font-size: 16px;
  color: var(--red-50);
  margin-top: 16px;
  text-align: center;
`;
// Loading fallback component
const AgentLoadingFallback = ()=>/*#__PURE__*/ _jsxs(LoadingContainer, {
        children: [
            /*#__PURE__*/ _jsx(LoadingSpinner, {}),
            /*#__PURE__*/ _jsx(LoadingText, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "agent.loading",
                    defaultMessage: "Loading Agent Preview..."
                })
            })
        ]
    });
// Error boundary component
class AgentErrorBoundary extends React.Component {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error('Error loading agent preview:', error, errorInfo);
    }
    render() {
        const { hasError } = this.state;
        const { children } = this.props;
        if (hasError) {
            return /*#__PURE__*/ _jsx(ErrorContainer, {
                children: /*#__PURE__*/ _jsx(ErrorText, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "agent.error",
                        defaultMessage: "Failed to load agent preview. Please try again."
                    })
                })
            });
        }
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
export const AgentContent = ({ chatId, onBack })=>{
    const account = useAccount();
    return /*#__PURE__*/ _jsx(AgentContainer, {
        children: /*#__PURE__*/ _jsx(AgentErrorBoundary, {
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(AgentLoadingFallback, {}),
                children: /*#__PURE__*/ _jsx(TaskAgentPreviewPage, {
                    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
                    chatId: chatId,
                    onBack: onBack,
                    accountId: account.accountId
                }, account.accountId)
            })
        })
    });
};
